import { Box, Checkbox, Typography } from '@material-ui/core'
import { useState } from 'react'

export default function TooltipCheckbox({ title = undefined as any, initialChecked = false, onChange }: { title?: any, initialChecked?: boolean, onChange: (checked: boolean) => void }) {
	const [checked, setChecked] = useState(initialChecked)

	return (

		<Box display="flex" gridGap="8px" justifyContent="space-between" alignItems="center">
			<Typography variant="subtitle2">{title}</Typography>
			<Checkbox
				checked={checked}
				onChange={(event) => {
					const value = event.target.checked
					setChecked(value)
					onChange(value)
				}}
			/>
		</Box>
	)
}
